import React, { useEffect } from "react";
import AOS from "aos";
import "aos/dist/aos.css";
import "bootstrap/dist/css/bootstrap.min.css";

const PrivacyPolicyPage = () => {
  useEffect(() => {
    AOS.init({ duration: 1000, once: true });
  }, []);

  return (
    <div
      className="min-vh-100 d-flex flex-column justify-content-center"
      style={{
        background: "linear-gradient(to bottom right, #f5f9f6, #e0f2e9)",
        padding: "60px 15px",
      }}
    >
      <div className="container">
        <div
          className="card shadow-lg border-0 rounded-4"
          data-aos="fade-up"
          style={{ background: "#ffffffee", backdropFilter: "blur(5px)" }}
        >
          <div className="card-body p-5">
            <h1
              className="text-center mb-4 fw-bold"
              style={{ color: "#2e7d32" }}
              data-aos="zoom-in"
            >
              Privacy Policy
            </h1>
            <p className="text-muted text-center mb-5" data-aos="fade-up">
              At <strong>RoupanNaturals</strong>, we respect your privacy and are
              committed to protecting your personal information.
            </p>

            <div className="mb-4" data-aos="fade-right">
              <h4 className="fw-bold text-success">1. Information We Collect</h4>
              <p>
                We may collect personal details such as your name, email,
                shipping address, and payment details to process orders and
                improve our services.
              </p>
            </div>

            <div className="mb-4" data-aos="fade-left">
              <h4 className="fw-bold text-success">2. How We Use Your Data</h4>
              <p>
                Your information is used for order fulfillment, customer support,
                promotional updates (if opted in), and to enhance your shopping
                experience.
              </p>
            </div>

            <div className="mb-4" data-aos="fade-right">
              <h4 className="fw-bold text-success">3. Sharing of Data</h4>
              <p>
                We never sell your personal information. Limited data may be
                shared with trusted partners (like courier and payment gateways)
                solely for completing transactions.
              </p>
            </div>

            <div className="mb-4" data-aos="fade-left">
              <h4 className="fw-bold text-success">4. Data Security</h4>
              <p>
                We use encryption and industry-standard practices to ensure your
                personal data remains safe and protected.
              </p>
            </div>

            <div className="mb-4" data-aos="fade-right">
              <h4 className="fw-bold text-success">5. Contact Us</h4>
              <p>
                If you have any privacy-related queries, email us at: <br />
                📧{" "}
                <a href="mailto:privacy@roupannaturals.com">
                  privacy@roupannaturals.com
                </a>
              </p>
            </div>

            <div className="text-center mt-5">
              <button
                className="btn btn-success px-4 py-2 rounded-pill shadow-sm"
                onClick={() => window.history.back()}
                data-aos="zoom-in"
              >
                ← Back to Shop
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PrivacyPolicyPage;
